import React from 'react'
import { string, array, node, bool } from 'prop-types'
import { css } from '@emotion/react'

import HomeIcon from '@/assets/icons/home.inline.svg'
import Breadcrumb from './Breadcrumb'

const wrapperCss = css`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
  flex-wrap: no-wrap;
  overflow-x: auto;
  min-width: 0;
  width: 100%;
`

const styledHomeIconCss = css`
  margin-top: 2px;
`

const Breadcrumbs = ({
  items = [],
  includeHome = true,
  className,
  children,
}) => {
  return (
    <ul css={wrapperCss} className={className}>
      {includeHome && (
        <Breadcrumb
          key={'breadcrumb-home'}
          item={{
            path: '/',
            title: <HomeIcon css={styledHomeIconCss} />,
          }}
          includeIcon={items.length > 0}
        />
      )}

      {items.map(({ show = true, ...props }, index) => {
        if (show) {
          return (
            <Breadcrumb
              key={`breadcrumb-${index}`}
              item={props}
              includeIcon={items.length > index + 1}
            />
          )
        }

        return null
      })}

      {children}
    </ul>
  )
}

Breadcrumbs.propTypes = {
  items: array,
  includeHome: bool,
  className: string,
  children: node,
}

export default Breadcrumbs
